import { createFileRoute } from "@tanstack/react-router";
import { ProcessDiagramPage } from "src/components/views/spc/processDiagrams/ProcessDiagramPage.tsx";
import { ProcessDiagramApi } from "src/api/generated/spc/processDiagrams/processDiagramApi.ts";
import { useKeptAliveGeneratedView } from "src/routing/keepAlive/keptAliveView.ts";

export const Route = createFileRoute("/_authenticated/_shell/spc/processDiagrams/chartGroups/$chartGroupId")({
	staticData: {
		legacyViewKey: "chartGroupProcessDiagramPages",
		listGeneratedViews: async () =>
			(await ProcessDiagramApi.listChartGroups()).map((chartGroup) => ({
				id: chartGroup.id,
				title: chartGroup.name,
			})),
	},
	component: RouteComponent,
});

function RouteComponent() {
	const {
		view: { generatedId: id },
		isActive,
	} = useKeptAliveGeneratedView();
	return <ProcessDiagramPage sourceType={"CHART_GROUP"} sourceId={id} isActive={isActive} />;
}
